import Swal from "sweetalert2";

// Custom styles to ensure toast appears above MUI modals (z-index 1300)
const toastStyles = {
  popup: 'swal2-popup-high-z',
};

// Add global CSS for high z-index (injected once)
const addToastStyles = () => {
  if (!document.getElementById('swal-custom-z-index')) {
    const style = document.createElement('style');
    style.id = 'swal-custom-z-index';
    style.innerHTML = `
      .swal2-container { z-index: 99999 !important; }
    `;
    document.head.appendChild(style);
  }
};

// Initialize styles
addToastStyles();

export const showToastSuccess = (message = "Success", timer = 3000) => {
  Swal.fire({
    title: "Success",
    titleText: message,
    timer,
    timerProgressBar: true,
    showConfirmButton: false,
    icon: "success",
  });
};
export const showToastWarning = (message = "Warning", timer = 3000) => {
  Swal.fire({
    title: "Warning",
    titleText: message,
    timer,
    timerProgressBar: true,
    showConfirmButton: false,
    icon: "warning",
  });
};
export const showToastError = (message = "Error", timer = 3000) => {
  Swal.fire({
    title: "Error",
    titleText: message,
    timer,
    timerProgressBar: true,
    showConfirmButton: false,
    icon: "error",
  });
};
